import * as React from 'react';
import {

    List,
    EditButton,
    Datagrid,
    TextField,
    Link,
    useRecordContext,
    Filter,
    TextInput,
} from 'react-admin';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import useIsPermission from '../../hooks/useIsPermission';
import PermissionBasedActions from '../../common/PermissionBasedActionsButton';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';

const VideosLinkComponent = () => {
    const record = useRecordContext();
    return <Link
        to={`/videos?displayedFilters={}&filter=${encodeURIComponent(JSON.stringify({ videoSubjectId: record.id }))}`}>
        Videos
        (
        {record ? record.videoCount : 0}
        )
    </Link>
}
const ListFilter = (props: any) => (
    <Filter {...props}>
        <TextInput label="Search" source="name" alwaysOn />
    </Filter>
);

const VideoSubjectList = () => {
    const { isDeletable, isWritable, isUpdatable } = useIsPermission("VIDEO_SUBJECT");

    return (
        <div>
            <List
                filters={<ListFilter />}
                exporter={false}
                actions={<PermissionBasedActions isWritable={isWritable} />}
                queryOptions={{
                    refetchOnWindowFocus: false,
                    refetchOnReconnect: false,
                }}
            >
                <Datagrid>
                    <TextField source="name" sortable={false} />
                    <FormattedDateTimeField source="createdAt" sortable={false} />
                    <VideosLinkComponent />
                    {isUpdatable &&
                        <EditButton />
                    }
                    {isDeletable &&
                        <ConfirmDeleteButton />

                    }
                </Datagrid>
            </List>
        </div>
    );
};
export default VideoSubjectList;
